import { useApiQuery } from '../../hooks/use-api';
import { RecentSessionsResponse } from '../../types/api';

export function useRecentSessions() {
  const endpoint = '/sessions?status=Completed&limit=10&offset=0';
  return useApiQuery<RecentSessionsResponse>(['sessions', 'recent'], endpoint);
}